import { Action } from 'src/app/shared/models/action';
export class SearchActionPagination {
  totalCount: number;
  totalPages: number;
  pageNumber: number;
  pageSize: number;
  items: Action[];

  constructor(data?) {
    Object.assign(this, data);
  }
}

export class SearchMailsActionsParams {
  CourrierId?: number;
  TransmissionUserId?: number;
  ContactIdiAdmin?: number;
  ContactId?: number;
  /**
   * @note It's a date field
   * It has to be Belgian format : dd/MM/yyyy
   *
   */
  DtEchMin?: string;
  /**
   * @note It's a date field
   * It has to be Belgian format : dd/MM/yyyy
   *
   */
  DtEchMax?: string;
  /**
   * @note It's a date field
   * It has to be Belgian format : dd/MM/yyyy
   *
   */
  DtTransMin?: string;
  /**
   * @note It's a date field
   * It has to be Belgian format : dd/MM/yyyy
   *
   */
  DtTransMax?: string;
  Traite?: boolean;
  /**
   * @note It's a date field
   * It has to be Belgian format : dd/MM/yyyy
   *
   */
  DtTraitMin?: string;
  /**
   * @note It's a date field
   * It has to be Belgian format : dd/MM/yyyy
   *
   */
  DtTraitMax?: string;
  CalcTotal?: boolean;
  Action?: string;
  /**
   * @note Sort fields seperated by ','
   */
  ReplyToAction?: boolean;
  SortFields?: string;
  SortOrder?: 'ASC' | 'DESC';
  PageNumber?: number;
  PageSize?: number;

  constructor(data?) {
    Object.assign(this, data);
  }
}
